<div>
  <label for="attachments" class="form-label">{{ label }}</label>
  <i
    *ngIf="canDownloadAll"
    (click)="downloadAllAttachments()"
    title="Download All"
    class="fa fa-download margin-vertical-middle download-icon"
    style="float: right"
    aria-hidden="true"></i>
</div>
<label *ngIf="attachments?.length === 0" class="form-label">{{ noAttactmentLabel }}</label>
<div class="attachments-container">
  <ng-container *ngFor="let attachment of attachments; let i = index">
    <div class="file-show mb-2">
      <div class="attachment-container">
        <i class="fa fa-check-circle margin-vertical-middle"></i>
        <span
          (click)="checkDocType(attachment) ? previewDocument(attachment, i) : null"
          [ngClass]="{ highlightDoc: checkDocType(attachment) }"
          >{{ attachment?.name }}</span
        >
        <i
          (click)="deleteDocument(attachment, i)"
          class="fa fa-trash margin-vertical-middle delete-icon"
          style="float: right"
          aria-hidden="true">
        </i>
        <i
          class="fa fa-download margin-vertical-middle download-icon"
          aria-hidden="true"
          (click)="downloadDocument(attachment)"></i>
      </div>
      <div class="attachment-meta">
        {{ attachment?.createByName + ' | ' }} {{ attachment?.createdDatetime | date : 'h:mm a dd/MM/yyyy' }}
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="previewDocData.isPreviewVisible">
  <div>
    <app-document-preview
      [documentUrl]="previewDocData.previewDocumentUrl"
      [hasNext]="previewDocData.hasNext"
      [hasPrevious]="previewDocData.hasPrevious"
      (close)="closePreview()"
      (requestNextDocument)="handleRequestNextDocument()"
      (requestPreviousDocument)="handleRequestPreviousDocument()">
    </app-document-preview>
  </div>
</div>
